@if (properties$ | async; as properties) {
	@if (repositories$ | async; as repositories) {
		<stages-dialog2 #dialog>
			<stages-dialog-header />
			<form #form="ngForm" name="form" class="content" novalidate stagesFocusError>
				<h1 translate="properties"></h1>
				<div class="form">
					<div class="form-group">
						<div class="input-container md required">
							<label class="input-label" for="name" translate="files.name"></label>
							<input
								#nameControl="ngModel"
								id="name"
								name="name"
								type="text"
								class="text fullsize"
								tabindex="1"
								[(ngModel)]="properties.name"
								[stagesMaxLength]="maxLengthBig"
								required
								stagesAutofocus
							/>
							<div class="info">
								@if (form.submitted || nameControl.dirty || nameControl.touched) {
									<div class="errors" role="alert">
										@if (nameControl.errors?.max) {
											<div
												class="error"
												role="alert"
												translate="input.maxLength"
												[translateParams]="{ length: maxLengthBig }"
											></div>
										}
										@if (nameControl.errors?.required) {
											<div class="error" role="alert" translate="input.required"></div>
										}
									</div>
								}
								<div class="maxlength">{{ getLength(nameControl) }} / {{ maxLengthBig }}</div>
							</div>
						</div>
					</div>
					@if (properties.repositories.length > 0) {
						<div class="form-group">
							<div class="input-container md">
								<label class="input-label" for="type" translate="files.repository"></label>
								<select
									name="repository"
									[(ngModel)]="properties.repository"
									tabindex="2"
									[disabled]="properties.repositories.length == 1"
								>
									@for (repository of properties.repositories; track repository) {
										<option value="{{ repository.repositoryId }}">
											{{ repository.name }}
										</option>
									}
								</select>
								<div class="info"></div>
							</div>
						</div>
					}
					@if (isLocationManagable(properties)) {
						<div class="form-group">
							<div class="input-container md required">
								<label class="input-label" for="path" translate="files.path"></label>
								<input
									#pathControl="ngModel"
									id="path"
									name="path"
									type="text"
									class="text fullsize"
									tabindex="3"
									[(ngModel)]="properties.path"
									required
									[stagesMaxLength]="maxLengthBig"
								/>
								<div class="info">
									@if (form.submitted || pathControl.dirty || pathControl.touched) {
										<div class="errors">
											@if (pathControl.errors?.required) {
												<div class="error" role="alert" translate="input.required"></div>
											}
											@if (pathControl.errors?.max) {
												<div
													class="error"
													role="alert"
													translate="input.maxLength"
													[translateParams]="{ length: maxLengthBig }"
												></div>
											}
											@if (validationErrors.lengthDirectory) {
												<div class="error" role="alert" translate="files.properties.length.directory"></div>
											}
											@if (validationErrors.lengthName) {
												<div class="error" role="alert" translate="files.properties.length.filename"></div>
											}
											@if (validationErrors.patternDirectory) {
												<div
													class="error"
													role="alert"
													[translate]="getTranslatePattern(repositories, properties, 'directory')!"
												></div>
											}
											@if (validationErrors.patternName) {
												<div
													class="error"
													role="alert"
													[translate]="getTranslatePattern(repositories, properties, 'name')!"
												></div>
											}
										</div>
									}
									<div class="maxlength">{{ getLength(pathControl) }} / {{ maxLengthBig }}</div>
								</div>
							</div>
						</div>
					}
					@if (isLocationManagable(properties)) {
						<div class="form-group">
							<div class="input-container md">
								<label class="input-label" for="frozenVersion" translate="files.properties.version.frozen"></label>
								<input
									#versionControl="ngModel"
									id="frozenVersion"
									name="frozenVersion"
									type="text"
									class="text fullsize"
									tabindex="4"
									[(ngModel)]="properties.frozenVersion"
									[stagesMaxLength]="maxLengthSmall"
								/>
								<div class="info">
									<div class="errors">
										@if (versionControl.errors?.max) {
											<div
												class="error"
												role="alert"
												translate="input.maxLength"
												[translateParams]="{ length: maxLengthSmall }"
											></div>
										}
									</div>
									<div class="maxlength">{{ getLength(versionControl) }} / {{ maxLengthSmall }}</div>
								</div>
							</div>
						</div>
					}
					@if (isLocationManagable(properties) && !!properties.lifecycles.length) {
						<div class="form-group">
							<div class="input-container md">
								<label class="input-label" for="lifecycle" translate="files.properties.lifecycle"></label>
								<select name="lifecycle" [(ngModel)]="properties.lifecycle" class="fullsize" tabindex="5">
									@for (lifecycle of properties?.lifecycles; track lifecycle) {
										<option value="{{ lifecycle.id }}" [translate]="lifecycle.name"></option>
									}
								</select>
								<div class="info"></div>
							</div>
						</div>
					}
					@if (isSecurityLevelEditable(properties)) {
						<div class="input-container">
							<legend class="input-label" translate="security.level"></legend>
							<div class="radio" tabindex="6">
								<input
									id="level-open"
									type="radio"
									name="security-level"
									[value]="1"
									[(ngModel)]="properties.securityLevel"
								/>
								<label for="level-open" translate="security.level.1"></label>
							</div>
							@if (properties.maximumAvailableSecurityLevel >= 2) {
								<div class="radio" tabindex="7">
									<input
										id="level-project"
										type="radio"
										name="security-level"
										[value]="2"
										[(ngModel)]="properties.securityLevel"
									/>
									<label for="level-project" translate="security.level.2"></label>
								</div>
							}
							@if (properties.maximumAvailableSecurityLevel >= 3) {
								<div class="radio" tabindex="8">
									<input
										id="level-internal"
										type="radio"
										name="security-level"
										[value]="3"
										[(ngModel)]="properties.securityLevel"
									/>
									<label for="level-internal" translate="security.level.3"></label>
								</div>
							}
							@if (properties.maximumAvailableSecurityLevel >= 4) {
								<div class="radio" tabindex="9">
									<input
										id="level-confidential"
										type="radio"
										name="security-level"
										[value]="4"
										[(ngModel)]="properties.securityLevel"
									/>
									<label for="level-confidential" translate="security.level.4"></label>
								</div>
							}
							@if (properties.maximumAvailableSecurityLevel >= 5) {
								<div class="radio" tabindex="10">
									<input
										id="level-secret"
										type="radio"
										name="security-level"
										[value]="5"
										[(ngModel)]="properties.securityLevel"
									/>
									<label for="level-secret" translate="security.level.5"></label>
								</div>
							}
							<div class="info"></div>
						</div>
					}
				</div>
			</form>
			<stages-popup-footer [hasCancelButton]="false">
				<button class="sm cancel" (click)="dialog.close()" translate="cancel"></button>
				<button class="sm save" (click)="save(properties)" translate="save" [disabled]="!form.valid"></button>
			</stages-popup-footer>
		</stages-dialog2>
	}
}
